import { Proxy } from "@/gen/proxy_connect"
import { createPromiseClient } from "@connectrpc/connect"
import defaultTransport from "./transport"

const proxyClient = createPromiseClient<typeof Proxy>(Proxy, defaultTransport);

export default proxyClient;